module.exports = __webpack_public_path__ + "b827953bf105fae9b011c1ed0d69a369.svg";